import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const getUserDevicesService = (userToken: string) => {
  return axiosV3.get("/user/get-active-devices", {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
